import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import axios from 'axios';

export const INQUIRIES_CHANGED = 'inquiries-changed';

export const NewInquiriesBadge = () => {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    const load = () => axios.get('/api/admin/inquiries/count').then(({ data }) => setCount(data.new)).catch(() => {});
    load();
    const interval = setInterval(load, 60000);
    window.addEventListener(INQUIRIES_CHANGED, load);
    return () => {
      clearInterval(interval);
      window.removeEventListener(INQUIRIES_CHANGED, load);
    };
  }, [pathname]);

  if (count === 0) return null;
  const word = count === 1 ? 'nová poptávka' : count <= 4 ? 'nové poptávky' : 'nových poptávek';

  return (
    <Link
      to="/admin/inquiries"
      data-testid="global-new-inquiries-badge"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold pl-3 pr-4 py-2.5 rounded-full shadow-xl transition-colors duration-200"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
      </span>
      <Inbox size={18} />
      <span data-testid="global-new-inquiries-count">{count} {word}</span>
    </Link>
  );
};
